import { render, staticRenderFns } from "./Agradecimento.vue?vue&type=template&id=11f23cb0&scoped=true&"
import script from "./Agradecimento.vue?vue&type=script&lang=js&"
export * from "./Agradecimento.vue?vue&type=script&lang=js&"
import style0 from "./Agradecimento.vue?vue&type=style&index=0&id=11f23cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f23cb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f23cb0')) {
      api.createRecord('11f23cb0', component.options)
    } else {
      api.reload('11f23cb0', component.options)
    }
    module.hot.accept("./Agradecimento.vue?vue&type=template&id=11f23cb0&scoped=true&", function () {
      api.rerender('11f23cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/steps/Agradecimento.vue"
export default component.exports